import {del, get, post, put} from '../../utils/ApiUtil';
import DataProvider from '../../models/DataProvider';
import Page from '../../filters/Page';

/**
 * Get list of data providers
 *
 * @param filter
 * @returns {Promise<*>}
 */
export async function getDataProviders(filter) {
  const data = await get('/api/admin/data-providers', filter);
  return data.map(dp => new DataProvider(dp));
}

/**
 * Get paginated list of data providers
 *
 * @param filter
 * @returns {Promise<Page>}
 */
export async function getPaginatedDataProviders(filter) {
  const data = await get('/api/admin/data-providers/paginated', filter);
  return new Page(data, DataProvider);
}

/**
 * Get data provider details
 *
 * @param id
 * @returns {Promise<DataProvider>}
 */
export async function getDataProvider(id) {
  const data = await get('/api/admin/data-providers/' + id);
  return new DataProvider(data);
}

/**
 * Create a new data provider
 *
 * @param dataProvider
 * @returns {Promise<DataProvider>}
 */
export async function createDataProvider(dataProvider) {
  const data = await post('/api/admin/data-providers', dataProvider);
  return new DataProvider(data);
}

/**
 * Update an existing data provider
 *
 * @param dataProvider
 * @returns {Promise<DataProvider>}
 */
export async function updateDataProvider(dataProvider) {
  const data = await put('/api/admin/data-providers/' + dataProvider.id, dataProvider);
  return new DataProvider(data);
}

/**
 * Delete a data provider
 *
 * @param dataProvider
 * @returns {Promise<void>}
 */
export async function deleteDataProvider(dataProvider) {
  await del('/api/admin/data-providers/' + dataProvider.id, {});
}